import React, { Component } from 'react';
import _ from 'lodash';

import FileUpload from 'components/fileUpload/FileUpload';

class Import extends Component {
  constructor(props) {
    super(props);
    this.state = {items: [], error: null};
  }

  load = (csvString) => {
    const items = this.props.parseItems(csvString, this.props.meet);
    this.setState({items});
  }

  cleanItem = (item) => {
    const cleanedItem = _.cloneDeep(item);
    delete cleanedItem.match;
    if(item.divisions) {
      _.each(cleanedItem.divisions, (lifterDivision) => {
        delete lifterDivision.match;
      });
    }

    return cleanedItem;
  }

  save = () => {
    _.each(this.state.items, (item) => {
      const cleanedItem = this.cleanItem(item);
      this.props.addItem(this.props.meet._id, cleanedItem);
    });
    const count = _.size(this.state.items);
    this.setState({items: []}, () => this.props.onFinishBulkCreate(count));
  }

  render() {
    const { meet, exportItems, label, media } = this.props;
    const ItemsTable = this.props.itemsTable;

    return (
      <div className="import">
        <div className="util-row">
          <FileUpload
            accept=".csv"
            buttonText={`Select ${this.props.label} file`}
            onChange={this.load}
          />
          <button disabled={_.isEmpty(this.state.items)} onClick={this.save}>Confirm Import of {label}</button>
          <button onClick={() => exportItems(meet, [], 'import')}>Download Template</button>
        </div>
        <div className="table-wrapper">
          <ItemsTable meet={this.props.meet} items={this.state.items} media={media} />
        </div>
      </div>
    );
  }
}

export default Import;
